import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grow-0 min-h-10 gap-2 py-4" }
const _hoisted_2 = { class: "flex flex-col col-span-2" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_4 = { class: "flex items-center underline text-sm bg-next-gray-md-dark px-3" }
const _hoisted_5 = { class: "flex justify-end pt-3 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_SingleFileUpload = _resolveComponent("SingleFileUpload")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event))
  }, {
    header: _withCtx(() => _cache[5] || (_cache[5] = [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-lg font-bold" }, "Carica da Excel")
      ], -1)
    ])),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            "label-visible": false,
            modelValue: _ctx.file.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.file.name) = $event)),
            placeholder: "Name",
            errors: _ctx.getErrors('file_id')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SingleFileUpload, {
                file: _ctx.file.file,
                "onUpdate:file": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.file.file) = $event)),
                accept: ".xlx,.xls,.xlsx"
              }, {
                default: _withCtx(({props, methods}) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _withDirectives(_createElementVNode("a", {
                        class: "underline text-next-atp break-words cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadFile(_ctx.file?.file?.id)))
                      }, [
                        _createElementVNode("span", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.file?.file?.name), 1)
                        ])
                      ], 512), [
                        [_vShow, _ctx.file?.file?.id]
                      ]),
                      _withDirectives(_createElementVNode("span", null, "Vuoto", 512), [
                        [_vShow, !_ctx.file?.file?.id]
                      ])
                    ]),
                    _createVNode(_component_NextButton, {
                      variant: "outline-secondary",
                      onClick: methods.open,
                      class: "w-full h-10 px-4 col-start-2"
                    }, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.file?.file ? 'Cambia' : 'Allega'), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["file"])
            ]),
            _: 1
          }, 8, ["modelValue", "errors"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _withDirectives(_createVNode(_component_Alert, {
        class: _normalizeClass([_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.message), 1)
        ]),
        _: 1
      }, 8, ["class"]), [
        [_vShow, _ctx.message.length > 0]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NextButton, {
          variant: "primary",
          disabled: _ctx.loading,
          onClick: _ctx.carica,
          class: "py-2 px-4 flex items-center justify-center"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
              [_vShow, _ctx.loading]
            ]),
            _cache[8] || (_cache[8] = _createTextVNode(" Importa "))
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', false))),
          class: "col-start-3 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}